import { useEffect } from 'react';

import { PWA_INSTALL_BANNER_HEIGHT_PX, PWA_INSTALL_BANNER_VISIBLE_CLASS } from '../constants';
import { usePwaInstall } from '../hooks/usePwaInstall';
import PwaInstallBanner from './PwaInstallBanner';
import PwaInstallGuide from './PwaInstallGuide';

/**
 * Persistent top install bar + SpaßRadar-style install guide sheet.
 * Stays available on mobile until the PWA is installed / opened in standalone.
 */
export function PwaInstallPrompt() {
    const {
        platform,
        canPromptNativeInstall,
        shouldShowInstallUi,
        showInstallInstructions,
        openInstallInstructions,
        closeInstallInstructions,
        startInstallFlow,
    } = usePwaInstall();

    useEffect(() => {
        const root = document.documentElement;

        if (shouldShowInstallUi) {
            root.style.setProperty('--pwa-install-banner-height', `${PWA_INSTALL_BANNER_HEIGHT_PX}px`);
            root.classList.add(PWA_INSTALL_BANNER_VISIBLE_CLASS);
        } else {
            root.classList.remove(PWA_INSTALL_BANNER_VISIBLE_CLASS);
            root.style.removeProperty('--pwa-install-banner-height');
        }

        return () => {
            root.classList.remove(PWA_INSTALL_BANNER_VISIBLE_CLASS);
            root.style.removeProperty('--pwa-install-banner-height');
        };
    }, [shouldShowInstallUi]);

    if (!shouldShowInstallUi && !showInstallInstructions) {
        return null;
    }

    return (
        <>
            {shouldShowInstallUi ? (
                <PwaInstallBanner
                    onInstallClick={() => {
                        openInstallInstructions();
                    }}
                />
            ) : null}

            <PwaInstallGuide
                open={showInstallInstructions}
                platform={platform}
                canPromptNativeInstall={canPromptNativeInstall}
                onClose={closeInstallInstructions}
                onInstall={() => {
                    void startInstallFlow();
                }}
            />
        </>
    );
}

export default PwaInstallPrompt;
